/* eslint-disable react/style-prop-object */
import React, { useContext } from "react";
import Button from "../Button/Button";
import { popupcontext } from "../../../context/Popupscontext";
import trans, { isRTL } from "../../../utils";

export default function StepsOffcanvasFooter({
	addData,
	submitAttempt,
	text,
	setIsShown,
	onClose,
	step,
	totalsteps,
	setActiveOption,
	segment,
	disableNext,
	handleSubmit,
}) {
	let { handleClose } = useContext(popupcontext);
	console.log("Step", step);
	return (
		<div
			style={{
				backgroundColor: "white",
				width: "100%",
				padding: "16px",
				border: "1px solid #EBECF0",
			}}
		>
			<div
				style={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
				}}
			>
				{step === 0 ? (
					<Button
						type="default"
						htmlType="button"
						text={trans("Cancel")}
						onClick={() => {
							handleClose("form");
							onClose?.();
						}}
					/>
				) : (
					<Button
						type="default"
						htmlType="button"
						text={trans("Previous")}
						onClick={() => {
							setActiveOption(segment[step - 1]?.value);
						}}
					/>
				)}
				{step !== totalsteps ? (
					<Button
						type="default"
						htmlType="button"
						text={trans("Next")}
						onClick={() => {
							setActiveOption(segment[step + 1]?.value);
						}}
						disabled={disableNext()}
					/>
				) : (
					<Button
						type="primary"
						htmlType="button"
						onClick={handleSubmit}
						text={trans("Save")}
					/>
				)}
			</div>
			{submitAttempt && !addData.isValid ? (
				<div className={`validation ${isRTL ? "text-start" : "text-end"}`}>
					{trans("Please Check Required Inputs")}
				</div>
			) : (
				""
			)}
		</div>
	);
}
